import React, { FC, useMemo } from 'react';
import { StyledContentMap, StyledMapList } from './styled';
import { MapList } from './components/';
import { IM82FindDealerMapBlockViewModel } from './models';
import { useCheckoutState } from '../../hooks/useCheckoutState';
import { filterDuplicateMarkers } from './utils/filterDuplicateMarkers';
import { generateMapMarkers } from './utils/generateMapMarkers';
import { ZipCodeSearch } from './components/ZipCodeSearch';
import { DropPointTypeFilter } from './components/DropPointTypeFilter';
import { usePostnordDropPoints } from './lib/usePostnordDropPoints';
import { DropPointDto } from '~/lib';
import { ShippingMethod, Store } from '~/lib/data-contract/salesforce';
import { InfoMessage } from '~/shared/components';
import styles from './DeliveryAddressMap.module.scss';

type Props = {
    optionList?: DropPointDto[] | Store[] | undefined | null;
    selectOptionShopDelivery?: (variant: any) => void;
    selectedCarrier?: ShippingMethod;
};

type ComponentProps = IM82FindDealerMapBlockViewModel & Props;

export const DeliveryAddressMap: FC<ComponentProps> = ({
    optionList,
    selectOptionShopDelivery,
    selectedCarrier,
}) => {
    const mapMarkers = useMemo(() => generateMapMarkers(optionList), [optionList]);
    const { zipCode, setZipCode } = useCheckoutState();
    const { visibleMarkers, disclaimer, showFilter, dropPointType, setDropPointType } =
        usePostnordDropPoints(mapMarkers, selectedCarrier);

    return (
        <StyledContentMap>
            <StyledMapList>
                <ZipCodeSearch setZipCode={setZipCode} zipCode={zipCode} />

                {disclaimer && (
                    <InfoMessage className={styles.postnordDisclaimer}>{disclaimer}</InfoMessage>
                )}

                {showFilter && (
                    <DropPointTypeFilter value={dropPointType} onChange={setDropPointType} />
                )}

                <MapList
                    optionList={filterDuplicateMarkers(visibleMarkers)}
                    selectOptionShopDelivery={selectOptionShopDelivery}
                    selectedCarrier={selectedCarrier}
                />
            </StyledMapList>
        </StyledContentMap>
    );
};
